// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__z3av3","tab":"Tabs_tab__cZe+I","activeTab":"Tabs_activeTab__qZrdF"};